export const MAIN_URL = "https://stroyka.blog.olx.kz:8443"